export class AddRestoreAtlasPrivateLinkRequest {
    'region';
    'vpcEndpointId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpcEndpointId",
            "baseName": "vpcEndpointId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AddRestoreAtlasPrivateLinkRequest.attributeTypeMap;
    }
    constructor() {
    }
}
